import React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
// utils
import { required } from 'utils/validators'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
`

interface IIncomingProps {
  isEdit: boolean
  hideModal: () => void
}

interface IFormData {
  active: boolean
  label: string
  value: string | number
}

type IFormProps = InjectedFormProps<IFormData, IIncomingProps>

type IProps = IIncomingProps & IFormProps

const OptionEditForm: React.FC<IProps> = ({ handleSubmit, hideModal }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <ReduxSwitch name={'active'} label={'Active'} />
      <ReduxInput name={'label'} label={'Label'} validate={[required]} />
      <ReduxInput name={'value'} label={'Value'} validate={[required]} />
      <ButtonsWrapper>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess>
          Save
        </Button>
        <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Form>
  )
}

export default reduxForm<IFormData, IIncomingProps>({
  form: Forms.FIELD_OPTION_EDIT_FORM,
  enableReinitialize: true
})(OptionEditForm)
